import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconDismissFilterGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 10C3.25 6.27208 6.27208 3.25 10 3.25C13.7279 3.25 16.75 6.27208 16.75 10C16.75 13.7279 13.7279 16.75 10 16.75C6.27208 16.75 3.25 13.7279 3.25 10ZM10 1.75C5.44365 1.75 1.75 5.44365 1.75 10C1.75 14.5563 5.44365 18.25 10 18.25C14.5563 18.25 18.25 14.5563 18.25 10C18.25 5.44365 14.5563 1.75 10 1.75ZM8.03033 6.96967C7.73744 6.67678 7.26256 6.67678 6.96967 6.96967C6.67678 7.26256 6.67678 7.73744 6.96967 8.03033L8.93934 10L6.96967 11.9697C6.67678 12.2626 6.67678 12.7374 6.96967 13.0303C7.26256 13.3232 7.73744 13.3232 8.03033 13.0303L10 11.0607L11.9697 13.0303C12.2626 13.3232 12.7374 13.3232 13.0303 13.0303C13.3232 12.7374 13.3232 12.2626 13.0303 11.9697L11.0607 10L13.0303 8.03033C13.3232 7.73744 13.3232 7.26256 13.0303 6.96967C12.7374 6.67678 12.2626 6.67678 11.9697 6.96967L10 8.93934L8.03033 6.96967Z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconDismissFilterSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconDismissFilterGroup {...props} />
    </svg>
  );
};
